package com.eladfinish.bible.contest.screens.lexicographicalSort

import androidx.compose.runtime.Immutable
import androidx.compose.runtime.Stable
import com.eladfinish.bible.contest.arch.ActionKt
import com.eladfinish.bible.contest.arch.EffectKt
import com.eladfinish.bible.contest.arch.StateKt
import com.eladfinish.bible.contest.screens.browse.tableOfContents.model.OutputChapters
import com.eladfinish.bible.contest.screens.lexicographicalSort.model.LexicographicalTable

@Immutable
data class LexicographicalSortPdfViewerState(
    val htmlState: HtmlState,
    val savedPdfName: String?,
    val savedPdfUri: String?,
    val canOpenPdf: Boolean,
    val isLoading: Boolean,
    val pdfEmailDialogState: PdfEmailDialogState,
    /** Drives which single bottom action is shown: SINGLE -> save, BY_MIKUD/ALL -> email. */
    val outputChapters: OutputChapters,
) : StateKt {

    @Stable
    sealed class HtmlState {
        data object Loading : HtmlState()

        /**
         * @param fullHtml complete table, used for the saved/emailed PDF.
         * @param previewHtml trimmed teaser shown in the WebView.
         * @param previewTable the rows of [previewHtml] as data, shown where there is no WebView.
         */
        data class Ready(
            val fullHtml: String,
            val previewHtml: String,
            val previewTable: LexicographicalTable,
        ) : HtmlState()
        data class Error(val message: String) : HtmlState()
    }

    @Stable
    sealed class PdfEmailDialogState {
        data object Hidden : PdfEmailDialogState()
        data class Visible(
            val firstName: String = "",
            val lastName: String = "",
            val email: String = "",
            val saveDetails: Boolean = true,
        ) : PdfEmailDialogState()
    }
}

sealed interface LexicographicalSortPdfViewerAction : ActionKt {
    data object SavePdfClicked : LexicographicalSortPdfViewerAction
    data object EmailPdfClicked : LexicographicalSortPdfViewerAction
    data class PdfEmailConfirmed(
        val firstName: String,
        val lastName: String,
        val email: String,
        val saveDetails: Boolean,
    ) : LexicographicalSortPdfViewerAction
    data object PdfEmailDialogDismissed : LexicographicalSortPdfViewerAction
    data class OpenPdf(val uri: String) : LexicographicalSortPdfViewerAction
}

sealed interface LexicographicalSortPdfViewerEffect : EffectKt {
    data class ShowToast(val text: String) : LexicographicalSortPdfViewerEffect
    data class ShowLoadingSnackbar(val text: String) : LexicographicalSortPdfViewerEffect
    data object DismissSnackbar : LexicographicalSortPdfViewerEffect
    data class ShowPdfSavedSnackbar(
        val pdfName: String,
        val pdfUri: String,
        val canOpen: Boolean,
    ) : LexicographicalSortPdfViewerEffect
}
